import { http } from '@/utils/request'
import { IResultDefault } from './commonInterface'

// 云平台老接口
const fromKf = 'apix.mj.com' ||  'apix.major.com' ||  'apix.majorbio.com' ||  'apix.sg.com' ||  'apix.sanger.com' ||  'apix.i-sanger.com' 

// 获取用户基本信息
export function fetchUserInfo(params: any): Promise<IResultDefault> {
  params = {
    ...params,
    from:fromKf // 临时的参数，后面可能会删除，用于区分baseURL
  }
  return http.httpRequestGet('kf/userInfo', params)
}

// 单个标记已读（公告）
export function fetchNoticeReadSingleNotice(params: any): Promise<IResultDefault> {
  params = {
    ...params,
    from:fromKf // 临时的参数，后面可能会删除，用于区分baseURL
  }
  return http.httpRequestPost('kf/noticeRead', params)
}

// 全部标记已读（公告）
export function fetchNoticeReadAllNotice(params: any): Promise<IResultDefault> {
  params = {
    ...params,
    from:fromKf // 临时的参数，后面可能会删除，用于区分baseURL
  }
  return http.httpRequestGet('kf/noticeReadAll', params)
}

// 站内信（导航栏消息）
export function fetchStationNoticeList(params: any): Promise<IResultDefault> {
  params = {
    ...params,
    from:fromKf // 临时的参数，后面可能会删除，用于区分baseURL
  }
  return http.httpRequestGet('notice/list', params)
}

// 系统通知（导航栏消息）
export function fetchSystemNoticeList(params: any): Promise<IResultDefault> {
  params = {
    ...params,
    from:fromKf // 临时的参数，后面可能会删除，用于区分baseURL
  }
  return http.httpRequestGet('cloud_notice/header-list', params)
}

// 单个标记已读（站内信）
export function fetchNoticeReadSingleStation(params: any): Promise<IResultDefault> {
  params = {
    ...params,
    from:fromKf // 临时的参数，后面可能会删除，用于区分baseURL
  }
  return http.httpRequestPost('notice/set_read', params)
}

// 单个标记已读（系统通知）
export function fetchNoticeReadSingleSystem(params: any): Promise<IResultDefault> {
  params = {
    ...params,
    from:fromKf // 临时的参数，后面可能会删除，用于区分baseURL
  }
  return http.httpRequestPost('cloud_notice/set_read', params)
}

// 全部标记已读（站内信）
export function fetchNoticeReadAllStation(params: any): Promise<IResultDefault> {
  params = {
    ...params,
    from:fromKf // 临时的参数，后面可能会删除，用于区分baseURL
  }
  return http.httpRequestPost('notice/set_read_all', params)
}

// 全部标记已读（系统通知）
export function fetchNoticeReadAllSystem(params: any): Promise<IResultDefault> {
  params = {
    ...params,
    from:fromKf // 临时的参数，后面可能会删除，用于区分baseURL
  }
  return http.httpRequestPost('cloud_notice/set_read_all', params)
}





